var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.icon,{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.label),expression:"label"}],tag:"component",staticClass:"w-4 h-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }